import { Component } from "@angular/core";

@Component({
    selector: 'hx-accordion-header, hxa-accordion-header',
    template: `<ng-content></ng-content>`
})
export class AccordionHeaderComponent {

}